import { render, staticRenderFns } from "./DashboardPostings.vue?vue&type=template&id=64861afe"
import script from "./DashboardPostings.vue?vue&type=script&lang=ts"
export * from "./DashboardPostings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64861afe')) {
      api.createRecord('64861afe', component.options)
    } else {
      api.reload('64861afe', component.options)
    }
    module.hot.accept("./DashboardPostings.vue?vue&type=template&id=64861afe", function () {
      api.rerender('64861afe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/cards/DashboardPostings.vue"
export default component.exports